import React from "react";
import { Link } from "react-router-dom";
import BookCallButton from "components/booking/BookCallButton";
import "./AIServices.css";

const AI_SERVICES = [
  {
    icon: "fa-robot",
    title: "AI Agents & Workflow Automation",
    text: "Autonomous agents that research, decide and act across your tools — CRMs, email, ERPs and internal APIs — cutting hours of manual work.",
    tags: ["Tool calling", "Multi-agent", "MCP"],
  },
  {
    icon: "fa-comments",
    title: "Chatbots & AI Assistants",
    text: "24/7 customer support and sales assistants grounded in your knowledge base, on web, WhatsApp, Slack or inside your app.",
    tags: ["WhatsApp", "Web chat", "Voice"],
  },
  {
    icon: "fa-database",
    title: "RAG & Enterprise Knowledge Search",
    text: "Ask questions of your documents, wikis and databases in plain language, with cited answers and role-based access control.",
    tags: ["Vector DB", "Embeddings", "Citations"],
  },
  {
    icon: "fa-file-invoice",
    title: "Document Intelligence",
    text: "Extract structured data from invoices, contracts, resumes and forms with OCR + LLMs — then validate and push it into your systems.",
    tags: ["OCR", "Extraction", "Classification"],
  },
  {
    icon: "fa-plug-circle-bolt",
    title: "AI Integration for Existing Products",
    text: "Add copilots, smart search, summarisation and recommendations to the web or mobile apps you already have — no rebuild required.",
    tags: ["Copilots", "Smart search", "APIs"],
  },
  {
    icon: "fa-microphone-lines",
    title: "Voice AI & Speech",
    text: "Voice agents for calls and bookings, real-time transcription, meeting notes and multilingual text-to-speech for Indian and global languages.",
    tags: ["STT", "TTS", "Call agents"],
  },
  {
    icon: "fa-eye",
    title: "Computer Vision",
    text: "Image and video understanding for quality inspection, retail analytics, ID verification and visual search.",
    tags: ["Detection", "OCR", "Video"],
  },
  {
    icon: "fa-chart-line",
    title: "Predictive Analytics & ML",
    text: "Forecast demand, score leads, detect fraud and churn with custom machine-learning models trained on your data.",
    tags: ["Forecasting", "Scoring", "Anomalies"],
  },
  {
    icon: "fa-sliders",
    title: "Custom LLMs, Fine-tuning & LLMOps",
    text: "Fine-tune and self-host open models, evaluate quality, monitor cost and latency, and keep sensitive data inside your cloud.",
    tags: ["Fine-tuning", "Evals", "Private hosting"],
  },
];

const MODELS = ["OpenAI GPT", "Anthropic Claude", "Google Gemini", "Meta Llama", "Mistral", "LangChain", "Pinecone", "Hugging Face"];

function AIServices({ showPageLink = true }) {
  return (
    <section className="wrapper ai-services" id="ai-solutions">
      <div className="container py-15 py-md-17">
        <div className="row text-center">
          <div className="col-md-10 offset-md-1 col-lg-8 offset-lg-2">
            <h2 className="fs-16 text-uppercase ai-eyebrow mb-3">AI Solutions</h2>
            <h3 className="display-4 text-white mb-4 px-xl-10">
              Put AI to work across your business — not just in a demo.
            </h3>
            <p className="lead ai-lead mb-10">
              We design, build and run production AI systems that are secure,
              measurable and integrated with the tools your team already uses.
            </p>
          </div>
        </div>

        <div className="row g-4">
          {AI_SERVICES.map((service) => (
            <div className="col-md-6 col-xl-4" key={service.title}>
              <div className="ai-card h-100">
                <span className="ai-icon">
                  <i className={`fa-solid ${service.icon}`} />
                </span>
                <h4 className="text-white mt-4 mb-2">{service.title}</h4>
                <p className="mb-4">{service.text}</p>
                <div className="ai-tags">
                  {service.tags.map((tag) => (
                    <span key={tag}>{tag}</span>
                  ))}
                </div>
              </div>
            </div>
          ))}
        </div>

        <div className="ai-models text-center mt-12">
          <p className="fs-14 text-uppercase mb-4">Models & platforms we work with</p>
          <div className="d-flex flex-wrap justify-content-center gap-2">
            {MODELS.map((model) => (
              <span key={model} className="ai-model">{model}</span>
            ))}
          </div>
          <div className="d-flex justify-content-center flex-wrap gap-3 mt-10">
            <BookCallButton className="btn btn-lg btn-primary rounded ai-btn">
              Book an AI discovery call
            </BookCallButton>
            {showPageLink && (
              <Link to="/generative-ai" className="btn btn-lg btn-outline-white rounded ai-btn">
                See how we deliver AI
              </Link>
            )}
          </div>
        </div>
      </div>
    </section>
  );
}

export default AIServices;
